import { findGeocodeCache as findGeocodeCacheOp } from '@gql/operations'
import { type GqlExecutor } from '@hopdrive/sdk-core'
import { normalizeInputForAlias } from '../../utils/normalize'
import type { GeocodeResult } from '../../types'

export interface FindGeocodeCacheParams {
  address: string
  executor?: GqlExecutor
}

export interface GeocodeCacheEntry {
  geocode_result: GeocodeResult
  expires_at: string
}

/**
 * Find a cached geocode result for the given address.
 * Returns null if not found or expired.
 *
 * @see performance-optimizations.md#4-global-geocoding-cache
 */
export async function findGeocodeCache(
  params: FindGeocodeCacheParams
): Promise<GeocodeResult | null> {
  const normalizedAddress = normalizeInputForAlias(params.address)

  const geocodeCache = await findGeocodeCacheOp(
    { normalizedAddress },
    { executor: params.executor }
  )

  const entry = geocodeCache?.[0]
  if (!entry) {
    return null
  }

  // Double-check expiration (Hasura filter should handle this, but be safe)
  const expiresAt = new Date(entry.expires_at)
  if (expiresAt <= new Date()) {
    return null
  }

  return entry.geocode_result as GeocodeResult
}
